
<template>
  <div>
    <v-select
      :items="all_forms"
      v-model="form"
      label="Selecione um formulário da lista"
      item-text="name"
      item-value="id"
    ></v-select>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: "FormStepConfig",
  data() {
    return {
      form: null
    }
  },
  mounted () {
    this.getForms();
  },
  methods: {
    getForms() {
      this.loading_forms = true;
      this.indexForms({ solution_id: this.solutionID}).then(() => {
        this.loading_forms = false;
      })
    },
    ...mapActions({
      indexForms: "Form/index"
    })
  },
  computed: {
    ...mapState({
      all_forms: state => state.Form.allForms,
      solutionID: state => state.Solution.solutionID
    })
  },
  watch: {
    solutionID(nv, ov) {
      if (nv) {
        this.indexForms({ solution_id: this.solutionID});
      } else if (nv == false) {
      }
    }
  },
}
</script>

<style scoped>

</style>